import { Component, Input, OnInit } from '@angular/core';
import { OrderService } from 'src/app/services/order.service';
import { saveAs } from 'file-saver';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { TranslateService } from '@ngx-translate/core';
import { CustomerInfoService } from 'src/app/services/customer-info.service';
import { FileService } from 'src/app/services/file.service';
import { CommonService } from 'src/app/services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Px2RemService } from 'src/app/services/px2-rem.service';
import { CustomerService } from 'src/app/services/customer.service';
import { HttpResponse } from '@angular/common/http';
import * as JSZip from 'jszip';
import { SharedDataService } from 'src/app/services/sharedDataService.service';
import { environment } from 'src/environments/environment';
interface ItemData {
  orderNo: string;
  poNo: string;
  customerId: string;
  itemNo: number;
  currency: string;
  poItemNumber: string;
  enteredMaterialNumber: string;
  orderedMaterialNumber: string;
  cbf: string;
  materialStatus: string;
  productDescription: string;
  realItemStatus: string;
  realItemStatusDisplayName: string;
  unitPrice: string;
  orderQuantity: 1;
  openQuantity: string;
  scheduleQuantity: 1;
  scheduleConfirmedDeliveryDate: string;
  messages: string;
  totalNetValue: string;
  vat: string;
  totalValueWithTax: string;
  reasonForCancellation: string;
  totalWeight: string;
  unitWeight: string;
  totalVolume: string;
  unitVolume: string;
  statisticsMap: any;
  batch: any;
  deliveryInfoVOList: any;
  deliveryScheduleVOList: any;
  orderCreateDate: string;
  canCanCel: boolean,
  visible: boolean,
  quantityUnit: string,
  customerRequestDeliveryDate:string,
  moq:string,
  orderType: string,
  orderTypeDisplayName: string,
  asnCreateDate: string,
  externalId: string,
  ztpInboundDeliveryDate: string,
}
@Component({
  selector: 'item-history',
  templateUrl: './item-history.component.html',
  styleUrls: ['./item-history.component.less'],
})
export class ItemHistoryComponent implements OnInit {
  @Input() tabSelectedIndex: number | undefined;
  searchFormData!: FormGroup;
  ItemData: ItemData[] = [];
  isReset:boolean = false;
  exportLoading = false;
  pagination = {
    total: 0,
    pageIndex: 1,
    pageSize: 10,
    pageSizeOptions: [10, 20, 50],
  };
  sortList: any = [

  ];
  isSpinning = true;
  isDealerPortal: boolean = false;
  orderTypeFilterList: Array<{ label: string; value: string }> = [];
  constructor(
    private orderService: OrderService,
    private commonService: CommonService,
    private fb: FormBuilder,
    private fileService: FileService,
    private message: NzMessageService,
    private translate: TranslateService,
    private customerInfoService: CustomerInfoService,
    private router: Router,
    private px2RemService: Px2RemService,
    private route: ActivatedRoute,
    private customerService: CustomerService,
    private sharedData: SharedDataService,
  ) {
    this.sharedData.currentData.subscribe(data => {
      this.isDealerPortal = data.isDealerPortal;
    });
  }
  codeTypeList: any = [

  ];
  statusList: any = [
  ];
  shippingAddressList: Array<any> = [];
  expandSet = new Set<string>();
  customer: any;
  firstLoading:boolean = true;
  onExpandChange(id: string, checked: boolean): void {
    if (checked) {
      this.expandSet.add(id);
    } else {
      this.expandSet.delete(id);
    }
  }
  filterOption(input: string, option: any): boolean {
    const shippingAddress = option.nzValue;
    const customerCode = shippingAddress?.customerCode?.toLowerCase() || '';
    const street = shippingAddress?.street?.toLowerCase() || '';
    const customerName = shippingAddress?.customerName?.toLowerCase() || '';

    const search = input.toLowerCase();
    return customerCode.includes(search) || street.includes(search) || customerName.includes(search);
  };
  getColorByStatus(status: string, isBackground: boolean, isBorder: boolean): string {
    let color = "";
    switch (status) {
      case "Being Processed":
        color = isBackground ? "#FEF5E9" : (isBorder ? "#F6C172" : "#F19F23");
        break;
      case "Open":
        color = isBackground ? "#F9F2F9" : (isBorder ? "#C279BE" : "#9E2896");
        break;
      case "Credit blocked":
        color = isBackground ? "#F9F2F9" : (isBorder ? "#C279BE" : "#9E2896");
        break;
      case "Completed":
        color = isBackground ? "#DEF5F3" : (isBorder ? "#84BDBA" : "#18837E");
        break;
      default:
        color = isBackground ? "#F2F3F4" : (isBorder ? "#B2B9C0" : "#A0A0A0");
        break;
    }
    return color;
  }
  // init
  ngOnInit(): void {
    this.translate.onLangChange.subscribe(() => {
      if (this.tabSelectedIndex == 1 && !this.firstLoading) {
        this.updateData();
        this.initData();
      }
    });
    this.route.queryParams.subscribe(params => {
      const tabSelectNumber = params['tabSelectNumber'];
      let status = [];
      if (tabSelectNumber == 1) {
        status.push('Open');
        status.push('Being Processed');
      }
      this.searchFormData = this.fb.group({
        orderDate: [[], []],
        itemStatusList: [status, []],
        orderTypeList: ['', []],
        keywordsType: ['orderedMaterialNumber', []],
        keywords: ['', []],
        shipTo: [null, []],
        sortType: ['oi.order_create_date/desc', []],
      });
      this.updateData();
      this.initData();
      this.firstLoading = false;
    });
    this.customerService.selectedCustomer$.subscribe(() => {
      if (this.tabSelectedIndex == 1 && !this.firstLoading) {
        this.initData();
      }
    });
  }

  clear():void{
    this.isReset = true;
    this.searchFormData.patchValue({
      orderDate: [],
      itemStatusList: [],
      orderTypeList: '',
      keywordsType: 'orderedMaterialNumber',
      keywords: '',  
      shipTo: null, 
      sortType: 'oi.order_create_date/desc'
    }, { emitEvent: false });
    this.getList();
    this.isReset = false;
  }

  initData(): void {
    this.getList();
    let param = {
      pageNum: 1,
      pageSize: -1
    };
    this.customerInfoService.getShippingAddresses(param).subscribe(({ data }) => {
      this.shippingAddressList = data.records || [];
    })

  }

  updateData(): void {
    this.sortList = [
      { name: this.translate.instant('ORDER_DATE_DESC'), value: 'oi.order_create_date/desc' },
      { name: this.translate.instant('ORDER_DATE_ASC'), value: 'oi.order_create_date/asc' },
      { name: this.translate.instant('PO_ASC'), value: 'oi.po_no/asc' },
      { name: this.translate.instant('PO_DESC'), value: 'oi.po_no/desc' },
      { name: this.translate.instant('ORDER_DESC'), value: 'oii.order_no/desc' },
      { name: this.translate.instant('ORDER_ASC'), value: 'oii.order_no/asc' },
    ];
    this.codeTypeList = [
      { name: this.translate.instant('BY_MATERIAL_NUMBER'), value: 'orderedMaterialNumber' },
      { name: this.translate.instant('BY_PO_NUMBER'), value: 'poNo' },
      { name: this.translate.instant('By_Bosch_Order_No'), value: 'orderNo' },
    ];
    this.statusList = [
      { name: this.translate.instant('OPEN'), value: 'Open' },
      { name: this.translate.instant('BEING_PROCESSED'), value: 'Being Processed' },
      { name: this.translate.instant('CREDIT_BLOCKED'), value: 'Credit blocked' },
      { name: this.translate.instant('COMPLETED'), value: 'Completed' },
      { name: this.translate.instant('CANCELLED'), value: 'Cancelled' },
    ];
    this.orderTypeFilterList = [
      { label: this.translate.instant('ORDER_TYPE_ZCU'), value: 'ZCU' },
      { label: this.translate.instant('ORDER_TYPE_ZEA'), value: 'ZEA' },
      { label: this.translate.instant('ORDER_TYPE_ZSD2'), value: 'ZSD2' },
      { label: this.translate.instant('ORDER_TYPE_ZSO'), value: 'ZSO' },
      { label: this.translate.instant('ORDER_TYPE_YKNA'), value: 'YKNA' },
      { label: this.translate.instant('ORDER_TYPE_ZTP'), value: 'ZTP' },
      { label: this.translate.instant('ORDER_TYPE_ZRP'), value: 'ZRP' },
      { label: this.translate.instant('ORDER_TYPE_YATK'), value: 'YATK' },
      { label: this.translate.instant('ORDER_TYPE_ZRPD'), value: 'ZRPD' },
      { label: this.translate.instant('ORDER_TYPE_ZCA'), value: 'ZCA' },
      { label: this.translate.instant('ORDER_TYPE_ZCWR'), value: 'ZCWR' },
      { label: this.translate.instant('ORDER_TYPE_ZCFC'), value: 'ZCFC' },
    ];
  }
  changeKeywords() {
    this.searchFormData.get('keywords')?.setValue('');
  }
  async cancelItem(item: ItemData): Promise<void> {
    let params = {
      cancelItems: [
        {
          itemNo: item.itemNo,
          productId: item.orderedMaterialNumber
        },
      ],
      salesOrderNo: item.orderNo
    };
    await this.orderService.cancelItem(params).subscribe((result) => {
      if (result.rtnData.result) {
        this.message.create(
          'success',
          this.translate.instant('OPERATION_SUCCESS')
        );
        this.getList();
      } else {
        if (result.rtnData.errorMessage.length > 0) {
          this.message.create(
            'error',
            result.rtnData.errorMessage[0].message
          );
        } else {
          this.message.create(
            'error',
            this.translate.instant('OPERATION_FAILED')
          );
        }
      }
    });;
  }
  /*
   ** search filter
   *
   */
  handleChange(e: Event): void {
    if(!this.isReset){
      this.pagination.pageIndex = 1;
      this.getList();
    }
    
  }

  /*
   ** get item data
   *
   */
  getList() {
    this.isSpinning = true;
    const [sortType, ascType] = this.searchFormData.value.sortType.split('/');
    const dynamicObject: { [key: string]: string } = {
      [this.searchFormData.value.keywordsType]:
        this.searchFormData.value.keywords,

    };
    let params = {
      ...dynamicObject,
      size: this.pagination.pageSize,
      current: this.pagination.pageIndex,
      endDate: this.searchFormData.value.orderDate
        ? this.commonService.formatDateString(this.searchFormData.value.orderDate[1]) ?? ''
        : '',
      beginDate: this.searchFormData.value.orderDate
        ? this.commonService.formatDateString(this.searchFormData.value.orderDate[0]) ?? ''
        : '',
      itemStatusStr: this.searchFormData.value.itemStatusList.join(','),
      orderType: this.searchFormData.value.orderTypeList,
      shipTo: this.searchFormData.value.shipTo?.customerCode ?? '',
      column: sortType,
      order: ascType
    };
    this.orderService.queryItemData(params).subscribe((result: any) => {
      const { rtnCode, rtnData } = result;
      if (rtnCode === 10000) {
        const { records, total } = rtnData;
        this.ItemData = records.map((item: any) => {
          return { ...item, visible: false };
        });
        this.pagination.total = total;
        //If the keyword has a value, this.expandSet.add (id)
        if (this.searchFormData.value.keywords && records.length > 0) {
          records.map((item: ItemData) => {
            this.expandSet.add(item.orderNo + item.itemNo);
          })
        } else {
          this.expandSet.clear();
        }
      }
      this.isSpinning = false;
    });
    if(environment.production) {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const customer = JSON.parse(localStorage.getItem('customer') || '{}');
      const keysString = Object.keys(params).join(',');
      const valuesString = Object.values(params)
        .map(value => {
          // 如果值是数组（如 orderType），先转为字符串，或者根据需求处理 null/undefined
          if (Array.isArray(value)) {
            return value.join('|'); // 数组内部建议用不同分隔符，以免混淆
          }
          return value ?? ''; // 处理 null 或 undefined
        })
        .join(',');
      (window as any).dataLayer.push({
        event: 'dp_order_detail_filter_click',
        from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
        event_type: keysString,
        event_name: '',
        portal_name: this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount,
        event_content: valuesString,
      });
    }
  }
  pageSizeChange(pageSize: number) {
    this.pagination.pageSize = pageSize;
    this.pagination.pageIndex = 1;
    this.getList();
  }

  pageIndexChange(pageIndex: number) {
    this.pagination.pageIndex = pageIndex;
    this.getList();
  }

  onInputEnter(event: any): void {
    event.preventDefault();
    this.getList();
  }
  convertPxToRem(px: number): string {
    return this.px2RemService.px2rem(px);
  }

  /*
   ** export item List
   *
   */
  async exportExcel(): Promise<void> {
    this.exportLoading = true;
    const [sortType, ascType] = this.searchFormData.value.sortType.split('/');
    await this.fileService
      .exportToExcel(
        `/eshop_backend/orderItemInfo/export?size=${this.pagination.pageSize}&current=${this.pagination.pageIndex}&endDate=${this.searchFormData.value.orderDate
          ? this.commonService.formatDateString(this.searchFormData.value.orderDate[1]) ?? ''
          : ''}&beginDate=${this.searchFormData.value.orderDate
            ? this.commonService.formatDateString(this.searchFormData.value.orderDate[0]) ?? ''
            : ''}&itemStatusStr=${this.searchFormData.value.itemStatusList.join(',')}&shipTo=${this.searchFormData.value.shipTo?.customerCode ?? ''}&${this.searchFormData.value.keywordsType}=${this.searchFormData.value.keywords}&column=${sortType}&order=${ascType}`
      ).subscribe(async (response: HttpResponse<Blob>) => {
        const unzipped = await JSZip.loadAsync(response.body!); //  ZIP
        // map the unzip file
        for (const [filename, fileObj] of Object.entries(unzipped.files)) {
          if (filename.endsWith('.xlsx') || filename.endsWith('.xls')) {
            const excelData = await fileObj.async('blob'); // read as Blob
            saveAs(excelData, decodeURIComponent(filename));
          }
        }
        this.exportLoading = false;
      },
        (error: any) => {
          console.error('Error exporting Zip:', error);
        })
    if (environment.production) {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const customer = JSON.parse(localStorage.getItem('customer') || '{}');
      (window as any).dataLayer.push({
        event: 'dp_order_download_click',
        from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
        event_type: 'item status',
        event_name: 'order download',
        portal_name: this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount,
        event_content: this.searchFormData.value.itemStatusList.join(','),
      });
    }
  }

  canCancel(date: string): boolean {
    let targetTime = new Date(date);
    targetTime.setHours(new Date(date).getHours() + 1);
    return new Date() <= targetTime;
  }
  goPage(url: string, data: any): void {
    const country = localStorage.getItem("country");
    this.router.navigate([`${country}/${url}`], { queryParams: { orderNo: data } });
  }
}
